import { render, staticRenderFns } from "./SpeakConfig.vue?vue&type=template&id=06535a80&scoped=true&"
import script from "./SpeakConfig.vue?vue&type=script&lang=js&"
export * from "./SpeakConfig.vue?vue&type=script&lang=js&"
import style0 from "./SpeakConfig.vue?vue&type=style&index=0&id=06535a80&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.7.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06535a80",
  null
  
)

export default component.exports